import { Icons as e } from "../../Icons/Icons.mjs";
import { Button as t } from "../../Button/Button.mjs";
import { DropdownMenuContent as n } from "../../DropdownMenu/DropdownMenuContent.mjs";
import { DropdownMenuItem as r } from "../../DropdownMenu/DropdownMenuItems.mjs";
import { DropdownMenu as i, DropdownMenuTrigger as a } from "../../DropdownMenu/DropdownMenuRoot.mjs";
import "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/QuickActions/components/QuickActionsMoreMenu.tsx
var c = ({ actions: c }) => /* @__PURE__ */ s(i, { children: [/* @__PURE__ */ o(a, {
	asChild: !0,
	children: /* @__PURE__ */ s(t, {
		variant: "ghost",
		size: "sm",
		children: ["More", /* @__PURE__ */ o(e.ChevronDown, { size: 14 })]
	})
}), /* @__PURE__ */ o(n, {
	align: "end",
	children: c.map((e) => /* @__PURE__ */ s(r, {
		disabled: e.disabled,
		onSelect: () => e.onClick?.(),
		children: [e.icon, e.label]
	}, e.id))
})] });
//#endregion
export { c as QuickActionsMoreMenu };
